var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBicycleList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3628 5.3728H19.6129",
    stroke: "#9E9E9E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6055 5.42188L18.1084 15.9811",
    stroke: "#9E9E9E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6172 5.3728L20.7301 13.2304",
    stroke: "#9E9E9E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1489 7.64575H21.6762",
    stroke: "#9E9E9E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.102 16.2715H4.74658",
    stroke: "#9E9E9E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.051 19.3984C22.6796 19.3984 23.9999 18.0134 23.9999 16.3048C23.9999 14.5962 22.6796 13.2112 21.051 13.2112C19.4223 13.2112 18.1021 14.5962 18.1021 16.3048C18.1021 18.0134 19.4223 19.3984 21.051 19.3984Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5966 16.3058C11.5966 18.0103 10.2805 19.3994 8.64765 19.3994C7.01478 19.3994 5.69873 18.0188 5.69873 16.3058",
    stroke: "#9E9E9E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49978 8.86614H2.99844C1.89361 8.86614 1 7.92868 1 6.76964V3.0965C1 1.93746 1.89361 1 2.99844 1H6.49978C7.60461 1 8.49822 1.93746 8.49822 3.0965V6.76964C8.49822 7.92868 7.60461 8.86614 6.49978 8.86614Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0732 16.2721L11.1641 12.0962",
    stroke: "#9E9E9E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74634 16.272C4.74634 16.272 4.64886 12.0449 8.32079 12.0449",
    stroke: "#9E9E9E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5131 12.0535H3.4292V8.86609H10.5131C11.3499 8.86609 12.0322 9.58197 12.0322 10.4598C12.0322 11.3376 11.3499 12.0535 10.5131 12.0535Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBicycleList);
export default __webpack_public_path__ + "static/media/icon-bicycle-list.feb23f05.svg";
export { ForwardRef as ReactComponent };